import { Main as Container } from 'Components/Main';
import { TitleForm } from 'Components/Form/styles';
import { FormSuccess } from 'Components/Form/Success';
import { Row } from 'Components/Grid';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { partnerOnboarding, editCompany, getCompanyById } from 'services/company-service';
import { stripTaxIdFormatting } from 'utils/tax_id_validators';
import { Detalhes } from './Details';
import { Dialog, PageHeader } from 'Components/ui';
import { useTranslation } from 'react-i18next';

export const CompaniesPartnerForm = () => {
  const { t } = useTranslation(['company']);
  const { id } = useParams();
  const navigate = useNavigate();
  const [idCompany, setIdCompany] = useState(null);
  const [finished, setFinished] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      active: true,
      cnpj: '',
      corporateName: '',
      country: '',
      defaultLanguage: '',
      description: '',
      domains: [],
      income: '',
      industry: '',
      managers: [],
      name: '',
      partner: false,
      roles: [],
      size: '',
      slug: '',
      signedPlan: 'Free',
    },
  });

  const handleReset = () => {
    reset();
    setFinished(false);
    setIdCompany(null);
    navigate('/companies-partner/add');
  };

  const transformData = data => ({
    ...data,
    cnpj: stripTaxIdFormatting(data.cnpj),
    managers: [],
  });

  const handleComplete = async () => {
    try {
      const res = id
        ? await editCompany(id, transformData(getValues()))
        : await partnerOnboarding(transformData(getValues()));
      if (res.status === 200 || res.status === 201) {
        setIdCompany(res.data._id ?? id);
        setFinished(true);
      } else {
        throw new Error('Ocorreu um erro ao tentar salvar/editar a Empresa!');
      }
    } catch (error) {
      Dialog.alert({
        title: 'Erro!',
        message: error.response?.data?.message ?? error.message,
        icon: 'error',
      });
    }
  };

  const getCompany = useCallback(async () => {
    try {
      const resCompany = await getCompanyById(id);
      Object.keys(resCompany.data).forEach(key => {
        setValue(key, resCompany.data[key]);
      });
    } catch (error) {
      Dialog.alert({
        title: 'Erro!',
        message: error.response?.data?.message ?? error.message,
        icon: 'error',
      });
    }
  }, [id, setValue]);

  useEffect(() => {
    if (!id) return;
    getCompany();
  }, [id, getCompany]);

  return (
    <Container>
      <PageHeader
        title={id ? t('company:companies.form.editTitle') : t('company:companies.form.addTitle')}
        segments={[
          { label: t('common:breadcrumbs.globalSettings') },
          { label: t('company:companies.title'), route: '/companies-partner' },
          { label: id ? t('company:companies.form.editTitle') : t('company:companies.form.addTitle') },
        ]}
      />
      <div className="card-content">
        {!finished && (
          <Row>
            <TitleForm>Detalhes do Cliente</TitleForm>
          </Row>
        )}
        {!finished && (
          <Detalhes
            control={control}
            register={register}
            handleNext={handleComplete}
            handleSubmit={handleSubmit}
            errors={errors}
            getValues={getValues}
            isLastStep
          />
        )}
        {finished && (
          <FormSuccess
            title="Cliente cadastrado com sucesso!"
            labelStartAgain="Cadastrar novo cliente"
            handleStartAgain={() => handleReset()}
            labelShow="Ver detalhes"
            handleShow={() => navigate('/companies-partner/show/' + idCompany)}
          />
        )}
      </div>
    </Container>
  );
};
